import React from 'react';

function NoLoading() {
  return (
    <div />
  );
}

export default NoLoading;
